import { KJUR } from 'jsrsasign';

function hexEncode(str) {
  let hex;

  let result = '';
  for (let i = 0; i < str.length; i += 1) {
    hex = str.charCodeAt(i).toString(16);
    result += hex.slice(-4);
  }

  return result;
}
function jwtEncode(payload, header) {
  const algHeader = Object.assign({ alg: 'HS256' }, header);
  const privateKey = process.env.VUE_APP_SIGN_KEY;
  const strPayload = JSON.stringify(payload);
  return KJUR.jws.JWS.sign(
    'HS256',
    algHeader,
    strPayload,
    hexEncode(privateKey)
  );
}

function jwtEncodeWithExpiry(payload, expiry = 300) {
  const now = Math.floor(Date.now() / 1000);
  const header = {
    iat: now,
    exp: now + expiry,
  };
  return jwtEncode(payload, header);
}

export { jwtEncode, jwtEncodeWithExpiry };
